/**
 * @file Route: spacesingle
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import { $all } from "@olmokit/dom";
import { globalData } from "@olmokit/core/data";
import "components/VisualQuote";
import slider from "components/VisualSlider";
import projects from "components/VisualProjects";
import { replaceFragment } from "@olmokit/core/fragments";
import { FormType } from "components/Form";
import "components/Related";
import { datalayerProd } from "components/Datalayer";
import "./index.scss";

console.log("Route spacesingle/index.js mounted.");
 
replaceFragment("contactForm", "components.FormType").then(() => FormType());
// FormType();

const glideEl = $all(".glide");
if (glideEl.length > 0) {
    if (globalData.sliderproducts) {
        slider('.VisualSlider:'+globalData.sliderproducts);
    }
    if (globalData.sliderprojects) {
        projects('.VisualProjects:'+globalData.sliderprojects);
    }
}

document.addEventListener('click',function(e){
    if (e.target.classList.contains('gtm-prodimg')) {
        datalayerProd(e.target.getAttribute('data-product'), 'false', 'true');
    }
});